// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__vP9ho","form":"styles_form__1Cd9T"};